import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../../../BusComponent';
import Orientation from "../../../../enums/Orientation";

class AutoAdjustButton extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
        };
    }

    render() {
        const { onAutoAdjust, intl } = this.props;

        return (
            <div className="basemap-editor__visualization-editor-container__btn-container medium">
                <button
                    className="basemap-editor__visualization-editor-container__btn-container__btn"
                    onClick={onAutoAdjust}
                >
                    <i className="material-icons"> auto_awesome_black </i>
                    <span> {intl.formatMessage({ id: 'legend.autoAdjust' })} </span>
                </button>
            </div>

        );
    }
}

AutoAdjustButton.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    onAutoAdjust: PropTypes.func.isRequired,
    orientation: PropTypes.oneOf(Object.keys(Orientation)),
    intl: PropTypes.object.isRequired,
};

AutoAdjustButton.defaultProps = {
    orientation: Orientation.LEFT,
}

export default injectIntl(AutoAdjustButton);
